import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=fdc7a4da&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default,CloudflareTurnstile: require('/home/nvpa/nvpa-corporate/nuxt/components/cloudflare/Turnstile.vue').default,GeneralContactCard: require('/home/nvpa/nvpa-corporate/nuxt/components/general/ContactCard.vue').default})
